import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Avatar from 'primevue/avatar';

import { useAvatar } from '../composables/useAvatar';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  setup(__props) {

const { label } = useAvatar();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Avatar), {
    shape: "circle",
    label: _unref(label),
    size: "large"
  }, null, 8, ["label"]))
}
}

})